// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : INACTIVE MEMBER REPORT
// MODIFIED DATE: 29-09-2025
/* eslint-disable import/no-anonymous-default-export */
import InActiveMemberActionTypes from './in-active-member.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// GET INACTIVE MEMBER LIST RESPONSE
	getInActiveMemberListResponse: null,
	// GET INACTIVE MEMBER LIST ARRAY
	getInActiveMemberListArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/*********** GET INACTIVE MEMBER LIST START *********************** */
		case InActiveMemberActionTypes.GET_INACTIVE_MEMBER_LIST_SUCCESS:
			return {
				...state,
				getInActiveMemberListResponse: action.payload,
				getInActiveMemberListArr: docodeHexResponse(
					action.payload,
					'GetInActiveMemberReportKey',
				),
			};

		case InActiveMemberActionTypes.GET_INACTIVE_MEMBER_LIST_FAILURE:
			return {
				...state,
				getInActiveMemberListResponse: action.payload,
				getInActiveMemberListArr: [],
			};

		case InActiveMemberActionTypes.GET_INACTIVE_MEMBER_LIST_RESPONSE_CHANGED:
			return { ...state, getInActiveMemberListResponse: null };
		/*********** GET INACTIVE MEMBER LIST END *********************** */
		default:
			return state;
	}
};
